import { type ActionIconProps, Button, type ButtonProps } from '@mantine/core';
import type { Icon } from '@tabler/icons-react';
import { IconDownload } from '@tabler/icons-react';

import { IconActionButton } from '#core/components/shared/IconActionButton.tsx';
import { triggerBlobDownload } from '#core/lib/utils/trigger-blob-download.ts';

export interface DownloadButtonProps extends Omit<ButtonProps & ActionIconProps, 'onClick'> {
  getData: () => string | Blob | Uint8Array | ArrayBuffer;
  getFileName: () => string;
  mimeType: string;
  icon?: Icon;
  tooltip?: string;
  label?: string;
  onClick?: () => void;
}

export function DownloadButton({
  getData,
  getFileName,
  mimeType,
  icon: IconComponent = IconDownload,
  tooltip = 'Download',
  label,
  onClick,
  ...props
}: DownloadButtonProps) {
  const clickAction = () => {
    triggerBlobDownload(getData(), getFileName(), mimeType);
    onClick?.();
  };
  if (label) {
    return (
      <Button leftSection={<IconComponent size={14} />} onClick={clickAction} {...props}>
        {label}
      </Button>
    );
  }
  return (
    <IconActionButton label={tooltip} onClick={clickAction} {...props}>
      <IconComponent size={14} />
    </IconActionButton>
  );
}
